export default {"src":"/_next/static/media/ArrowLeft.b808fab1.svg","height":89,"width":80,"blurWidth":0,"blurHeight":0};